/*
 * HomeReducer
 *
 * The reducer takes care of our data. Using actions, we can
 * update our application state. To add a new action,
 * add it to the switch statement in the reducer function
 *
 */

import produce from "immer";
import {
  LOADER_STATUS,
  PROFILE_INFO,
  SET_EINVOICE_RECO_TAX,
  SET_VARIANCE_DATA,
  SET_EINVOICE_RECO_TURNOVER,
  SET_EWAY_RECO_TAX,
  SET_EWAY_RECO_TURNOVER,
  SET_CLEAR_GRAPH
} from "./constants";

// The initial state of the App
export const initialState = {
  loaderStatus: false,
  profileData: [],
  varianceData: [],
  eInvoiceRecoTurnover: [],
  eInvoicerecoTax: [],
  ewayRecoTax: [],
  ewayRecoTurnoverData: []
};

/* eslint-disable default-case, no-param-reassign */
const EWayBillRecoReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOADER_STATUS:
      return {
        ...state,
        loaderStatus: action.loaderStatus
      };
    case PROFILE_INFO:
      return {
        ...state,
        profileData: action.profileData
      };
    case SET_VARIANCE_DATA:
      return {
        ...state,
        varianceData: action.varianceData
      };
    case SET_EINVOICE_RECO_TAX:
      return {
        ...state,
        eInvoicerecoTax: action.einvoiceRecoTax
      };
    case SET_EINVOICE_RECO_TURNOVER:
      return {
        ...state,
        eInvoiceRecoTurnover: action.einvoiceRecoTurnover
      };
    case SET_EWAY_RECO_TAX:
      return {
        ...state,
        ewayRecoTax: action.ewayRecoTax
      };
    case SET_EWAY_RECO_TURNOVER:
      return {
        ...state,
        ewayRecoTurnoverData: action.ewayRecoTurnoverData
      };
    case SET_CLEAR_GRAPH:
      return {
        ...state,
        varianceData: [],
        eInvoiceRecoTurnover: [],
        eInvoicerecoTax: [],
        ewayRecoTax: [],
        ewayRecoTurnoverData: []
      };
    default:
      return state;
  }
};

export default EWayBillRecoReducer;
